import {useMutation} from '@apollo/react-hooks';

import type {
    McfxAudienceSyncInAppInput,
    SyncMcfxAudience as SyncMcfxAudienceMutation,
    SyncMcfxAudienceVariables as SyncMcfxAudienceMutationVariables,
} from 'nutshell-graphql-types';

import GET_AUDIENCES from '../../../../../../core/select/queries/get-audiences.graphql';

import SYNC_MCFX_AUDIENCE from '../mutations/sync-mcfx-audience.graphql';

export function useSyncMcfxAudience(): {
    syncMcfxAudience: (input: McfxAudienceSyncInAppInput) => Promise<any>;
} {
    const [syncMcfxAudience, {loading}] = useMutation<
        SyncMcfxAudienceMutation,
        SyncMcfxAudienceMutationVariables
    >(SYNC_MCFX_AUDIENCE);

    return {
        syncMcfxAudience: (input: McfxAudienceSyncInAppInput) => {
            return syncMcfxAudience({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const newEmAudience =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.mcfxAudienceSyncInApp;

                    if (newEmAudience) {
                        const cacheResult = proxy.readQuery({
                            query: GET_AUDIENCES,
                        });

                        // @ts-expect-error
                        if (!cacheResult || !cacheResult.audiences) {
                            return;
                        }

                        proxy.writeQuery({
                            query: GET_AUDIENCES,
                            data: {
                                audiences: {
                                    // @ts-expect-error
                                    ...cacheResult.audiences,
                                    edges: [
                                        {
                                            cursor: newEmAudience.id,
                                            node: newEmAudience,
                                            __typename: 'AudiencesEdge',
                                        },
                                        // @ts-expect-error
                                    ].concat(cacheResult.audiences.edges),
                                },
                            },
                        });
                    }
                },
            }).then((mutationResult) => {
                return mutationResult && mutationResult.data
                    ? mutationResult.data.mcfxAudienceSyncInApp
                    : null;
            });
        },
        // @ts-expect-error
        isSyncing: loading,
    };
}
